import React from 'react';

const NewWindow = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <title>new_window</title>
    <path d="M22.5 22.5h-21v-21h12.9v-1h-13.9v23h23v-14.4h-1z"></path>
    <path d="M17.15 0.5v1h4.6l-13.3 13.35 0.7 0.7 13.35-13.3v4.5h1v-6.25z"></path>
  </svg>
);

export default NewWindow;
